<template>
  <v-footer bottom inset :color="returnColor()" dark app>
    <v-col cols="12" class="text-center"
      >Copyright © 2022 QQPay SDN BHD. All rights reserved</v-col
    >
  </v-footer>
</template>
<script>
export default {
  methods: {
    returnColor() {
      return `#${process.env.VUE_APP_COLOR}`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
</style>
